import http from './http'
import httpPortal from './http-portal'

class Dashboard {
  statusMailer (payload) {
    return http.get('/dashboard/assignors_preview/status_mailer', { params: { filter: payload } })
  }

  statusAccount (payload) {
    return http.get('/dashboard/assignors_preview/status_accounts', { params: { filter: payload } })
  }

  statusDocumentations (payload) {
    return http.get('/dashboard/assignors_preview/status_documentations', { params: { filter: payload } })
  }

  statusAssignments (payload) {
    return http.get('/dashboard/assignments_preview/status_assignments', { params: { filter: payload } })
  }

  statusAssignmentsAccepted (payload) {
    return http.get('/dashboard/assignments_preview/status_accepted', { params: { filter: payload } })
  }

  statusAssignmentsRejectedCanceled (payload) {
    return http.get('/dashboard/assignments_preview/status_rejected_canceled', { params: { filter: payload } })
  }

  statusAssignmentsCompleted (payload) {
    return http.get('/dashboard/assignors_preview/status_complete')
  }

  getSummary () {
    return http.get('/dashboard/assignors/summary')
  }

  fetchCorretor () {
    return http.get('/dashboard/assignors/corretor')
  }

  fetchForceRequest (payload) {
    return http.put(`/admin_back_office/force_send_assignment_request/${payload.id}`)
  }

  exportCnabFile (id) {
    return http.get(`/admin_back_office/export_cnab_file/${id}/download`)
  }

  generateTermoCessao (id) {
    return http.get(`/admin_back_office/export_assignment_request_term/${id}`, {
      responseType: 'blob',
      headers: { accept: 'application/json' }
    })
  }

  exportExcelAssigmentRequest (id) {
    return http.get(`/admin_back_office/export_assignment_request_excel/${id}`, {
      responseType: 'blob',
      headers: { accept: 'application/json' }
    })
  }

  exportCnabFileFromMultipleARs (ids) {
    return http.get(`/admin_back_office/export_cnab_file/download`, { params: { assignment_requests_ids: ids } })
  }

  loadSummaryDatatable (params) {
    let path = params ? `${'private/api/v1/invoices_summarize'}?${params}` : 'private/api/v1/invoices_summarize'
    return httpPortal.get(path)
  }
}

export default new Dashboard()



// WEBPACK FOOTER //
// ./src/services/dashboard.js